import styles from './Toggle.module.css';

/** On/off switch used by the notification preferences rows. */
export function Toggle({ checked = false, onChange, disabled = false, label, className = '' }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      className={`${styles.toggle} ${checked ? styles.on : ''} ${className}`}
      onClick={() => onChange?.(!checked)}
    />
  );
}
